export const scrollIntoView = async (elementName: string) => {
  const element: HTMLInputElement | null =
    document.querySelector<HTMLInputElement>(`input[name='${elementName}']`)

  if (element) {
    const rect = element.getBoundingClientRect()

    const topInView = rect.top >= 0 && rect.top <= window.innerHeight
    const bottomInView = rect.bottom >= 0 && rect.bottom <= window.innerHeight

    // If the element is out of view, scroll it into view
    if (!topInView || !bottomInView) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}

export const scrollToLocation = async (elementName: string) => {
  const element: HTMLInputElement | null =
    document.querySelector<HTMLInputElement>(`input[name='${elementName}']`)

  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}
